import React from 'react';
import {Box, Paper, Typography} from '@mui/material';

interface PaperProps {
  id?: string;
  children?: any;
  elevation?: 0 | 1 | 2 | 3;
  headline?: string;
  headVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body2';
  padding?: 'small' | 'medium' | 'large' | 'xlarge';
  sx?: any;
}

const FaPaper = (props: PaperProps) => {

  const {
    id,
    children,
    elevation,
    headline,
    headVariant,
    padding,
    sx
  } = props;

  const paddingSizes = {
    small: {padding: '.45rem .45rem .75rem .45rem'},
    medium: {padding: '.95rem .95rem 1.45rem .95rem'},
    large: {padding: '1.45rem 1.45rem 1.95rem 1.45rem'},
    xlarge: {padding: '2.5rem 2.5rem 3rem 2.5rem'}
  };

  return (
      <Box id={id ?? ''} sx={sx}>
        <Paper elevation={elevation ?? 2} sx={padding ? paddingSizes[padding] : paddingSizes.medium}>
          {headline &&
              (<Typography variant={headVariant ?? 'h3'} sx={{marginBottom: '1.5rem'}}
                           dangerouslySetInnerHTML={{__html: headline}}></Typography>)
          }
          {children}
        </Paper>
      </Box>
  );
};

export default FaPaper;
